import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RegisterAsInspector } from 'src/app/models/enums/register-as.enum';

@Component({
    selector: 'user-main-info',
    templateUrl: './user-main-info.component.html',
    styleUrls: [],
    standalone: false
})
export class UserMainInfoComponent implements OnInit {
  
  @Input() subForm!: UntypedFormGroup;
  @Input() userData: any;
  @Input() registrationAs: any[] = [];
  
  readonly RegisterAsInspector = RegisterAsInspector;
  
  ngOnInit(): void {
    this.patchValues();
  }

  patchValues(){
    this.subForm.patchValue({
      first_name: this.userData.first_name,
      last_name: this.userData.last_name,
      email: this.userData.email,
      mobile : this.userData.mobile,
      commercial_registration_no: this.userData.commercial_registration_no,
      commercial_registration_date: this.userData.commercial_registration_date ? new Date(this.userData.commercial_registration_date) : null,
      communicator_name: this.userData.communicator_name
    });
  }

  getRegistrationAsName(): string {
    const registrationValue = this.userData?.registration_in_ayen_as;
    
    if (!registrationValue) {
      return '-';
    }
    
    if (typeof registrationValue === 'object' && registrationValue?.name) {
      return registrationValue.name;
    }
    
    const registrationId = typeof registrationValue === 'object' ? registrationValue?.id : registrationValue;
    const registration = this.registrationAs?.find(r => r.id === registrationId);
    
    return registration?.name ?? '-';
  }

  getRegistrationId(): number | null {
    const registrationValue = this.userData?.registration_in_ayen_as;
    
    if (!registrationValue) {
      return null;
    }
    
    return typeof registrationValue === 'object' ? registrationValue?.id : registrationValue;
  }

}
